import $ from "jquery";

const global_obj = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : undefined;
if (global_obj) {
	global_obj.$ = $;
	global_obj.jQuery = $;
}

export default $;
